export default "__VITE_ASSET__b62f032a__"